import * as AlertNotification from '@givebutter/primitives/alert-notification';
import { Box } from '@givebutter/primitives/box';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppState } from 'customHooks/useAppState';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import PoweredByStripe from 'images/powered-by-stripe-gray.svg?react';

const ConnectedBankAccount = () => {
    const { accountId, hasFailingPayouts, paymentAccount } = useCurrentAccount();
    const { apiUrl } = useAppState();

    return (
        <Box className={'flex max-w-[400px] flex-col gap-4 p-4'}>
            <div className={'flex justify-between gap-4'}>
                <p className="text-lg font-medium">Connected Bank Account</p>
                <PoweredByStripe />
            </div>
            <p className="text-gray-600">
                Givebutter uses Stripe to securely process donations on your behalf and to transfer
                the funds you raise to your bank account.
            </p>
            <div>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className={'flex items-center gap-1 font-medium'}
                    href={`${apiUrl}/dashboard/accounts/${accountId}/payment_account_dashboard`}
                >
                    View Stripe Account
                    <FontAwesomeIcon icon={faArrowRight} />
                </a>
            </div>
            {hasFailingPayouts && (
                <AlertNotification.Root type={'error'}>
                    Your last payout failed. Please check or update your bank account information
                    and try again.
                </AlertNotification.Root>
            )}
            {paymentAccount?.merchant_status === 'pending' && (
                <AlertNotification.Root type={'warning'}>
                    Your Stripe account is missing information. You must complete onboarding to
                    continue receiving payouts.
                </AlertNotification.Root>
            )}
        </Box>
    );
};

export { ConnectedBankAccount };
